export default __webpack_public_path__ + "static/media/48t.ea091de3.jpg";